export enum MailboxSyncFields {
    API_CONFIG = 'apiConfig',
    USERNAME = 'username',
    BOXES = 'boxes',
    ACTIVE = 'active',
    MISSING_BOXES = 'missingBoxes',
    LAST_SYNCED_AT = 'lastSyncedAt',
    CREATED_AT = 'createdAt',
    UPDATED_AT = 'updatedAt',
}
